import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import CustomAmountPrice from '../Containers/CustomAmountPrice/CustomAmountPrice';
import ThemeProvider from './ThemeProvider';

const ConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    selectedConfigurationMode={'designer'}
    renderAmountPrice={CustomAmountPrice}
    renderLicenseNotice={() => null}
    ThemeProvider={ThemeProvider}
  />
);

export default ConfiguratorScreen;
